import { CRUDMutations } from '@/utils/store-utilities'

const defaultItem = (item) => ({
  ...item,
})

export const state = () => ({
  item: null,
  items: [],
})

export const mutations = {
  ...CRUDMutations(defaultItem),
}

export const getters = {}

export const actions = {
  createCustomDuty({ commit }, item) {
    return this.$axios.$post('admin/customDuties/create', { ...item }).then((response) => {
      commit('add', { ...response.data })
      return response.data
    })
  },
  removeCustomDuty({ commit }, item) {
    return this.$axios.$delete(`admin/customDuties/${item.id}`).then((response) => {
      if (response.data) {
        commit('remove', item)
      }
    })
  },
  updateCustomDuty({ commit }, item) {
    return this.$axios.$put(`admin/customDuties/${item.id}`, { ...item }).then((response) => {
      commit('update', { ...response.data })
      return response.data
    })
  },
  fetchCustomDuty({ commit }, id) {
    return this.$axios.$get(`admin/customDuties/${id}`).then((response) => {
      return response.data
    })
  },
  fetchCustomDutys({ commit }) {
    return this.$axios.$get('admin/customDuties').then((response) => {
      commit('load', response.data)
      return response.data
    })
  },
}
